module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bj9ebj/tc-custom/9780795350764.jpg?1705006396944",
      "alt": "This image is the cover for the book Eyewitness Gospel"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Eyewitness Gospel\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The acclaimed Christian novelist and devotional author brings the Bible to life with this engaging fictionalized account of the Gospel and its writing.")]), _c('br'), _c('br'), _vm._v("A small and insignificant village a few miles south of Jerusalem has been chosen by the heavens for the event that will change history. No one has an inkling of what is to come save the young woman chosen out of obscurity—like the village—to play a central role in the grand, unfolding drama. "), _c('br'), _c('br'), _vm._v("In "), _c('i', [_vm._v("Eyewitness Gospel")]), _vm._v(", Michael Phillips applies his storytelling craft to a vivid retelling of Jesus’s life, death, and resurrection, as well as the tireless works of his apostles as they spread the good news.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael Phillips\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0